/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BrandDetailsDTO } from '../dto';
// @ts-ignore
import { BrandListByStatusDTO } from '../dto';
// @ts-ignore
import { CategoryDTO } from '../dto';
// @ts-ignore
import { DiscountCodeDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * DiscountCodeApi - axios parameter creator
 * @export
 */
export const DiscountCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscountCode: async (tenantId: string, employeeId: string, brandId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createDiscountCode', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createDiscountCode', 'employeeId', employeeId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('createDiscountCode', 'brandId', brandId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/discountCode/brands/{brandId}/code`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: async (tenantId: string, employeeId: string, brandId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBrand', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getBrand', 'employeeId', employeeId)
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('getBrand', 'brandId', brandId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/discountCode/brands/{brandId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all available brands
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands: async (tenantId: string, employeeId: string, categoryIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getBrands', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getBrands', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/discountCode/brands`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (tenantId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCategories', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCategories', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/discountCode/categories`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountCodeApi - functional programming interface
 * @export
 */
export const DiscountCodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountCodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiscountCode(tenantId: string, employeeId: string, brandId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountCodeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiscountCode(tenantId, employeeId, brandId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrand(tenantId: string, employeeId: string, brandId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDetailsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrand(tenantId, employeeId, brandId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all available brands
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrands(tenantId: string, employeeId: string, categoryIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandListByStatusDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrands(tenantId, employeeId, categoryIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(tenantId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(tenantId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DiscountCodeApi - factory interface
 * @export
 */
export const DiscountCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountCodeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscountCode(tenantId: string, employeeId: string, brandId: string, options?: any): AxiosPromise<DiscountCodeDTO> {
            return localVarFp.createDiscountCode(tenantId, employeeId, brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} brandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(tenantId: string, employeeId: string, brandId: string, options?: any): AxiosPromise<BrandDetailsDTO> {
            return localVarFp.getBrand(tenantId, employeeId, brandId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all available brands
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrands(tenantId: string, employeeId: string, categoryIds?: Array<string>, options?: any): AxiosPromise<BrandListByStatusDTO> {
            return localVarFp.getBrands(tenantId, employeeId, categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(tenantId: string, employeeId: string, options?: any): AxiosPromise<Array<CategoryDTO>> {
            return localVarFp.getCategories(tenantId, employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDiscountCode operation in DiscountCodeApi.
 * @export
 * @interface DiscountCodeApiCreateDiscountCodeRequest
 */
export interface DiscountCodeApiCreateDiscountCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiCreateDiscountCode
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiCreateDiscountCode
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiCreateDiscountCode
     */
    readonly brandId: string
}

/**
 * Request parameters for getBrand operation in DiscountCodeApi.
 * @export
 * @interface DiscountCodeApiGetBrandRequest
 */
export interface DiscountCodeApiGetBrandRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetBrand
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetBrand
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetBrand
     */
    readonly brandId: string
}

/**
 * Request parameters for getBrands operation in DiscountCodeApi.
 * @export
 * @interface DiscountCodeApiGetBrandsRequest
 */
export interface DiscountCodeApiGetBrandsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetBrands
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetBrands
     */
    readonly employeeId: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DiscountCodeApiGetBrands
     */
    readonly categoryIds?: Array<string>
}

/**
 * Request parameters for getCategories operation in DiscountCodeApi.
 * @export
 * @interface DiscountCodeApiGetCategoriesRequest
 */
export interface DiscountCodeApiGetCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetCategories
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof DiscountCodeApiGetCategories
     */
    readonly employeeId: string
}

/**
 * DiscountCodeApi - object-oriented interface
 * @export
 * @class DiscountCodeApi
 * @extends {BaseAPI}
 */
export class DiscountCodeApi extends BaseAPI {
    /**
     * 
     * @param {DiscountCodeApiCreateDiscountCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCodeApi
     */
    public createDiscountCode(requestParameters: DiscountCodeApiCreateDiscountCodeRequest, options?: AxiosRequestConfig) {
        return DiscountCodeApiFp(this.configuration).createDiscountCode(requestParameters.tenantId, requestParameters.employeeId, requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiscountCodeApiGetBrandRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCodeApi
     */
    public getBrand(requestParameters: DiscountCodeApiGetBrandRequest, options?: AxiosRequestConfig) {
        return DiscountCodeApiFp(this.configuration).getBrand(requestParameters.tenantId, requestParameters.employeeId, requestParameters.brandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all available brands
     * @param {DiscountCodeApiGetBrandsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCodeApi
     */
    public getBrands(requestParameters: DiscountCodeApiGetBrandsRequest, options?: AxiosRequestConfig) {
        return DiscountCodeApiFp(this.configuration).getBrands(requestParameters.tenantId, requestParameters.employeeId, requestParameters.categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DiscountCodeApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountCodeApi
     */
    public getCategories(requestParameters: DiscountCodeApiGetCategoriesRequest, options?: AxiosRequestConfig) {
        return DiscountCodeApiFp(this.configuration).getCategories(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
